'use strict';

let processInclude = require('core/util');

$(document).ready(function () {
  processInclude(require('core/login/login'));

});

